import { stringify } from "../../node_modules/querystring/index.esm.js";
import { isWebview } from "../../node_modules/@zillow/mortgage-webview-query-params/dist/mortgage-webview-query-params.esm.esm.js";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";
import { useState, useEffect } from "react";
import { getZillowURL } from "./ClosingCostCalculator.utils.esm.js";
function useCurrentRatesButtonUrl(pathBase = "mortgage-rates", params = {}) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    const path = isWebview() ? "mortgage/webviews/ZCQ.htm" : `${pathBase}/`;
    let queryString = stringify(omitBy(params, isNil));
    if (queryString) {
      queryString = `?${queryString}`;
    }
    setUrl(getZillowURL(path + queryString));
  }, [pathBase, params]);
  return url;
}
export {
  useCurrentRatesButtonUrl
};
